import { axios } from '@/utils/request'
const api = {
  source: '/finance/enterpriseBill',
  remark:'/finance/billRemark',
  create:'/finance/enterpriseStatement'
}
export function getSourceList (parameter) {
  return axios({
    url:  '/finance/enterpriseBill/list',
    method: 'get',
    params: parameter
  })
}
// export function getexportList (parameter) {
//   return axios({
//     url:  '',
//     method: 'get',
//     params: parameter
//   })
// }
export function getexportList (parameter) {
  return axios({
    url: '/finance/enterpriseBill/export',
    method: 'get',
    params: parameter,
    responseType: 'arraybuffer',
    headers: {
      'Content-Type': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
    }
  })
}

// 获取备注信息 好像没有用 可以直接通过表单就可以获取到当前条的数据
export function getremarkList (parameter) {
  return axios({
    url: api.remark + '/list',
    method: 'get',
    params: parameter
  })
}
export function saveremarkList (parameter) {
  return axios({
    url: api.remark + '/save',
    method: 'post',
    // params: parameter
    data: parameter,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
}
// 企业生成对账单
export function getenterGenerateState (parameter) {
  return axios({
    url: api.create + '/confirm',
    method: 'post',
    data: parameter,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
}
// 企业生成对账单
export function getEnterpriseList (parameter) {
  return axios({
    url: api.create + '/create',
    method: 'post',
    data: parameter,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
}

